import { createFileRoute, redirect } from "@tanstack/react-router";
import { api, edenFetch } from "@/lib/eden";

/**
 * Legacy `/card/sign/edit/<magic_link>` (the `group_card_invite` mail). Legacy signed
 * on the card's read magic; we sign on a separate `card_sign_token` (PRD 05 D2), so
 * this resolves: still signable → `/s/<token>`; already sent → the signer view;
 * gone → the sign page's own "no longer valid" state. Server: `/card/sign/legacy/:slug`.
 */
export const Route = createFileRoute("/card/sign/edit/$slug")({
  beforeLoad: async ({ params }) => {
    type Resolved = { kind: "sign"; token: string } | { kind: "sent"; read_slug: string };
    let res: Resolved | null = null;
    try {
      res = await edenFetch(api.api.card.sign.legacy({ slug: params.slug }).get());
    } catch {
      res = null;
    }
    if (res?.kind === "sign") {
      throw redirect({
        to: "/s/$signToken",
        params: { signToken: res.token },
        search: true,
        replace: true,
      });
    }
    if (res?.kind === "sent") {
      throw redirect({
        to: "/card/sign/view/$slug",
        params: { slug: res.read_slug },
        // Keep `slt` / `inv` — the email link's sign-in / address proof (Nick 10-13).
        search: true,
        replace: true,
      });
    }
    // Unknown magic: let the sign surface render its "link no longer valid" state
    // with the magic as the token — it 404s the same way a revoked token does.
    throw redirect({
      to: "/s/$signToken",
      params: { signToken: params.slug },
      search: true,
      replace: true,
    });
  },
  component: () => null,
});
